import { render, staticRenderFns } from "./ProjectAssetTileApprovalStatus.vue?vue&type=template&id=5d0857b7"
import script from "./ProjectAssetTileApprovalStatus.vue?vue&type=script&lang=js"
export * from "./ProjectAssetTileApprovalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports